import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import QuickInfoStrip from './components/QuickInfoStrip';
import AboutSection from './components/AboutSection';
import ReasonsSection from './components/ReasonsSection';
import MenuSection from './components/MenuSection';
import HoursSection from './components/HoursSection';
import ExperienceSection from './components/ExperienceSection';
import GallerySection from './components/GallerySection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import CinematicDivider from '@/components/feature/CinematicDivider';
import BackToTop from '@/components/feature/BackToTop';
import MobileBottomNav from '@/components/feature/MobileBottomNav';
import CookieConsent from '@/components/feature/CookieConsent';
import Preloader from '@/components/feature/Preloader';

export default function Home() {
  return (
    <main className="min-h-screen overflow-x-hidden bg-background-50 pb-16 md:pb-0">
      <Preloader />
      <Navbar />
      <HeroSection />
      <QuickInfoStrip />
      <AboutSection />
      <ReasonsSection />
      <MenuSection />
      <CinematicDivider
        quote="Dobri trenutki ne potrebujejo načrta."
        subquote="Samo dobro družbo in skodelico kave."
        image="https://public.readdy.ai/ai/img_res/edited_90ef0a8af71baaf7af0995cfea615695_3ddaa4a9.jpg"
        imageAlt="Topla notranjost lokala Guma Caffe Lounge Bar Gorišnica"
        imageTitle="Topla notranjost lokala Guma Caffe Lounge Bar Gorišnica"
      />
      <HoursSection />
      <ExperienceSection />
      <CinematicDivider
        quote="Najboljši trenutki so v družbi."
        subquote="Pridi, usedi se in deli trenutek z nami."
        image="https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/a4a84974d868f72c55958079e5b70b0b.png"
        imageAlt="Dve osvežilni pijači z limeto v kozarcih na terasi lokala"
        imageTitle="Osvežilne pijače na terasi Guma Caffe Lounge Bar Gorišnica"
      />
      <GallerySection />
      <ContactSection />
      <CinematicDivider
        quote="Se vidimo v Gumi?"
        subquote="Pridi na kavo, ostani zaradi vzdušja."
        image="https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/a8aec268cac0192721b3d5189e84d7be.png"
        imageAlt="Prostorna notranjost lokala Guma Caffe Lounge Bar s sedeži in osvetlitvijo"
        imageTitle="Notranjost lokala Guma Caffe Lounge Bar Zamušani"
        tall
      />
      <Footer />
      <BackToTop />
      <MobileBottomNav />
      <CookieConsent />
    </main>
  );
}